import alarm1 from './audio/alarm1.mp3';

export default [alarm1];
